export default {
  tpSegmentosResumo: {
    culturas_populares: 'Culturas populares',
    culturas_povos_indigenas: 'Culturas dos povos indígenas',
    expressoes_afrobrasileiras: 'Expressões culturais afro-brasileiras',
    tecnico_artistico: 'Técnico-artístico',
    patrimonio_cultural: 'Patrimônio Cultural',
  },

  headersOrganizacao: [
    {
      text: 'CNPJ',
      value: 'cnpj_formatado',
    },
    {
      text: 'Nome da Organização ou Entidade',
      value: 'no_organizacao',
    },
    {
      text: 'Segmento',
      value: 'segmento.ds_detalhamento',
    },
  ],

  opcoesStatusHabilitacao: [
    {
      st_habilitacao: '-1',
      ds_habilitacao: 'Pendente Avaliação',
    },
    {
      st_habilitacao: '0',
      ds_habilitacao: 'Não Habilitada',
    },
    {
      st_habilitacao: '1',
      ds_habilitacao: 'Habilitada Desclassificada',
    },
    {
      st_habilitacao: '2',
      ds_habilitacao: 'Habilitada Classificada',
    },
    {
      st_habilitacao: '3',
      ds_habilitacao: 'Habilitada',
    },
  ],

  PENDENTE_AVALIACAO: '-1',
  NAO_HABILITADA: '0',
  HABILITADA_DESCLASSIFICADA: '1',
  HABILITADA_CLASSIFICADA: '2',
  HABILITADA: '3',

  descricaoArquivos: {
    documento_identificacao_organizacao: 'Documento de identificação do representante legal responsável pela inscrição da organização ou entidade cultural (conforme item 2.8 do edital)',
    cpf_representante_organizacao: 'Documento de Cadastro de Pessoas Físicas (CPF) do representante legal responsável pela inscrição da organização ou entidade cultural',
    cnpj_organizacao: 'Comprovante do Cadastro Nacional da Pessoa Jurídica (CNPJ) que comprove a existência da entidade há pelo menos três anos',
    documento_constituicao_executiva_organizacao: 'Documento de constituição da atual diretoria e da presidência, ou cargo equivalente, da organização ou entidade cultural',
    documento_identificacao_executivo_organizacao: 'Documento de identificação (conforme item 2.8 do edital) do presidente, diretor executivo ou cargo equivalente',
    cpf_executivo_organizacao: 'Documento de Cadastro de Pessoas Físicas (CPF) do presidente, diretor executivo ou cargo equivalente',
    contrato_social_organizacao: 'Estatuto social ou contrato social atualizado, conforme o caso, devidamente registrado no órgão competente, de modo a comprovar o caráter cultural da entidade e seu ano de criação',
    relatorio_anual_atividade_organizacao: 'Relatório anual das atividades culturais dos últimos 06 (seis) anos (2016, 2017, 2018, 2019, 2020, 2021), com ações realizadas, no mínimo, em três anos, contendo, minimamente: o resumo de cada atividade, o local, o período de realização e o número de participantes',
    comprovativo_atividade_cultural_organizacao: 'Comprovação efetiva de que possui projetos ou atividades culturais realizados em ao menos 5 (cinco) estados de 2 (duas) macrorregiões brasileiras, a partir do exercício de 2016, por meio de: portfólio, folders, publicações, listas de presença, revistas, jornais, conteúdos de divulgação, links de vídeos, registros fotográficos ou outros materiais que permitam, minimamente, a identificação de data e local de realização das atividades e a aferição da veracidade das informações apresentadas. Anexar em único arquivo',
    lista_associados_atestada_organizacao: 'Lista de associados ou filiados atestada pelo dirigente da organização ou entidade cultural',
    comprovativo_atuacao_setor_cultural_organizacao: 'Documentação que comprove a atuação da organização ou entidade cultural em instâncias colegiadas do setor cultural, tais como conselhos, comissões ou câmaras, se houver, por meio de termo de posse ou portaria de designação de representante',
    comprovativo_realizacao_projeto_cultural_organizacao: 'Documentação que comprove a realização de projetos na área de pesquisa ou produção do conhecimento no campo da cultura a partir de 2016, tais como: publicações, pesquisa de campo e artigos científicos',
  },

  INDICADO_ORGANIZACAO_FILE_PATH: 'indicacao_organizacao',
  headersIndicacao: [
    {
      text: 'CNPJ',
      value: 'cnpj_formatado',
    },
    {
      text: 'Nome da Organização ou Entidade',
      value: 'no_organizacao',
    },
    {
      text: 'Segmento',
      value: 'segmento.ds_detalhamento',
    },
    {
      text: 'CPF do Indicado',
      value: 'nu_cpf  ',
    },
    {
      text: 'Indicado',
      value: 'no_indidcado',
    },
    {
      text: 'Tipo de Indicação',
      value: 'tp_indicacao',
    },
    {
      text: 'Habilitação',
      value: 'st_habilitacao',
    },
  ],

  descricaoArquivosIndicacao: {
    cpf_indicado: 'Cópia do documento de identificação (conforme item 2.8 deste edital) e CPF',
    cmpres_indicado: 'Comprovante de residência com o nome do indicado ou declaração de residência (ANEXO 6)',
    curriculo_indicado: 'Currículo',
    portifolio_indicado: 'Portifólio',
    foto_indicado: 'Foto de rosto',
    curriculo_resumido_indicado: 'Currículo resumido com as principais atuações',
    declaracao_indicado: 'Declaração do indicado de que possui disponibilidade para compor o Conselho Nacional de Política Cultural - CNPC, no triênio 2022/2025 (ANEXO 2 do edital)',
    autorizacao_indicado: 'Declaração que autoriza a Secretaria Especial da Cultura do Ministério do Turismo a divulgar as imagens e informações contidas na inscrição e que responsabiliza o candidato pelos documentos e materiais apresentados (ANEXO 2 do edital)',
    termo_indicado: 'Termo de indicação assinado pelo dirigente máximo da organização ou entidade cultural (ANEXO 4 do edital)',
  }
};
